module.exports = __webpack_public_path__ + "static/media/spirit.08bf674b.jpg";